export const GRAVATAR = 'https://gravatar.zeruns.com/avatar/'
export const DEFAULT_GRAVATAR = 'https://en.gravatar.com/userimage/141519065/45ed999d25f2a8be43c4957009cd91fd.png'
export const DEFAULT_GRAVATAR2 = 'https://en.gravatar.com/userimage/141519065/859fd373f0cb145826ca13a32b7673da.jpg'



// WEBPACK FOOTER //
// ./src/constant.js